import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Box from '@mui/material/Box';

const daysOfTheWeek = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
];
const today = new Date();

const columns: GridColDef[] = [
    { field: 'prepItem', headerName: 'Item', width: 90 },
    {
        field: 'firstDay',
        headerName: daysOfTheWeek[today.getDay()],
        type: 'number',
        width: 110,
    },
    {
        field: 'secondDay',
        headerName: daysOfTheWeek[(today.getDay() + 1) % 7],
        type: 'number',
        width: 110,
    },
    {
        field: 'thirdDay',
        headerName: daysOfTheWeek[(today.getDay() + 2) % 7],
        type: 'number',
        width: 110,
    },
    {
        field: 'fourthDay',
        headerName: daysOfTheWeek[(today.getDay() + 3) % 7],
        type: 'number',
        width: 110,
    },
    {
        field: 'fifthDay',
        headerName: daysOfTheWeek[(today.getDay() + 4) % 7],
        type: 'number',
        width: 110,
    },
    {
        field: 'sixthDay',
        headerName: daysOfTheWeek[(today.getDay() + 5) % 7],
        type: 'number',
        width: 110,
    },
    {
        field: 'seventhDay',
        headerName: daysOfTheWeek[(today.getDay() + 6) % 7],
        type: 'number',
        width: 110,
    },
];

const rows = [0, 1, 2, 3, 4, 5, 6, 7].map((val) => {
    return {
        id: 1,
        prepItem: 'test',
        firstDay: 1,
        secondDay: 2,
        thirdDay: 3,
        fourthDay: 4,
        fifthDay: 5,
        sixthDay: 6,
        seventhDay: 7,
    };
});

export function PrepGrid() {
    return (
        <Box sx={{ height: 319, width: '100%', backgroundColor: '#FFF' }}>
            <DataGrid
                rows={rows}
                columns={columns}
                pageSize={4}
                rowsPerPageOptions={[5]}
            />
        </Box>
    );
}
